/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Active_BadgeInputs */

const vi_irrigation_schedule_active_badge = /** @type {(inputs: Irrigation_Schedule_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang áp dụng`)
};

/**

* @param {Irrigation_Schedule_Active_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_active_badge = /** @type {((inputs?: Irrigation_Schedule_Active_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Active_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_active_badge(inputs)
});